import * as yup from "yup";

export const documentSchema = yup.object().shape({
  filename: yup.string().min(2, "File Name Must Be At Least 2 Characters").required("File Name is required"),
  createBy: yup.string().required(),
});
